module.exports = __webpack_public_path__ + "img/中财型材.f5940144.png";